import script from "./event-participant.vue?vue&type=script&setup=true&lang=ts"
export * from "./event-participant.vue?vue&type=script&setup=true&lang=ts"

const cssModules = {}
import style0 from "./event-participant.vue?vue&type=style&index=0&id=a65d766e&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__